import { formatCurrency } from "@sellar-io/common";
import { Button } from "@sellar-io/components";
import { useElements, useStripe } from "@stripe/react-stripe-js";
import type { Stripe, StripeElements } from "@stripe/stripe-js";

type PayButtonProps = {
  isActiveCredit: boolean;
  activeSelection: string | undefined;
  isPlacingOrder: boolean;
  activeGroup: {
    supplierId: number;
    total: number;
    currency: "gbp" | "sgd";
  };
  onPay: (
    _supplierId: number,
    _stripe: Stripe | null,
    _elements: StripeElements | null,
  ) => Promise<void>;
};

export const PayButton = ({
  isActiveCredit,
  activeSelection,
  isPlacingOrder,
  activeGroup,
  onPay,
}: PayButtonProps) => {
  const stripe = useStripe();
  const elements = useElements();

  const handlePayClick = () => {
    onPay(activeGroup.supplierId, stripe, elements);
  };

  return (
    <Button
      onClick={handlePayClick}
      disabled={
        isPlacingOrder ||
        !activeSelection ||
        (!isActiveCredit && (!stripe || !elements))
      }
      loading={isPlacingOrder}
      className="w-full"
    >
      {activeSelection === "credit-account"
        ? "Place order with supplier credit"
        : activeSelection === "sellar-credit"
          ? `Put ${formatCurrency(activeGroup.total, activeGroup.currency)} on Sellar Credit tab`
          : `Pay ${formatCurrency(activeGroup.total, activeGroup.currency)} by card`}
    </Button>
  );
};
